import React from 'react';
import { Switch, Route } from "react-router-dom";


import { 
  Home,
  Community, 
  Privacy, 
  Thankyou,
  Docs
} from './components/pages/index'


export const links = [
  {
    "text": "platform",
    "color": "#1F4AAD",
    "link": "platform",
  },
  {
    "text": "community",
    "color": "#DC3C3A",
    "link": "platform",
  },
  {
    "text": "contact",
    "color": "#F7DA49",
    "link": "platform",
  },
]


export default function Router() {

  return (
    <Switch>
      <Route path="/learn-more-about-minimaa" component={Community} />
      <Route path="/platform" component={Home} />
      <Route path="/thank-you" component={Thankyou} />
      <Route path="/privacy-policy" component={Privacy} />
      <Route path="/api-documentation/introduction" render={(props) => <Docs doc={"Introduction"}/>} />
      <Route path="/api-documentation/reference" render={(props) => <Docs doc={"Api-docs"}/>} />
      <Route path="/api-documentation" render={(props) => <Docs/>} />
      <Route path="/" component={Home} />
    </Switch>
  );
}
